module.exports = __webpack_public_path__ + "static/media/settings-background-image.2760f158.jpg";